/* unplugin-vue-components disabled */import script from "./HandicapView.vue?vue&type=script&setup=true&lang=js"
export * from "./HandicapView.vue?vue&type=script&setup=true&lang=js"

import "./HandicapView.vue?vue&type=style&index=0&id=e4678d84&step=true&lang=css"

const __exports__ = script;

export default __exports__